import { DrawerFormActionSummary, DrawerFormSection } from '../../../common/components';
import { drawerFieldSpan } from '../../../common/styles';
import { INTERNAL_MATERIAL_PURPOSE_OPTIONS } from '../../constants/internalMaterialPurposes';
import { getSupplyOrderInternalReason } from '../utils/getSupplyOrderInternalReason';
import {
  SUPPLY_DESTINATION_KINDS as KINDS,
  SUPPLY_DESTINATION_LABELS,
  SUPPLY_DESTINATION_TEXTS as TEXTS,
} from '../constants/supplyOrderDestinationConstants';

/** Presenta la imputación guardada sin confundirla con el depósito de recepción. */
const SupplyOrderDestinationSummary = ({ order }) => {
  if (!order.destination_kind) return null;
  const reason = getSupplyOrderInternalReason(order);
  const reasonLabel = INTERNAL_MATERIAL_PURPOSE_OPTIONS
    .find((option) => option.value === reason.internal_reason)?.label;
  const internalLabel = [reasonLabel, reason.internal_reason_detail].filter(Boolean).join(' · ');
  return (
    <DrawerFormSection title={TEXTS.title} sx={{ mx: 0 }}>
      <DrawerFormActionSummary
        label={TEXTS.kind}
        value={SUPPLY_DESTINATION_LABELS[order.destination_kind]}
        sx={drawerFieldSpan(4)}
      />
      <DrawerFormActionSummary
        label={order.destination_kind === KINDS.PROJECT ? TEXTS.project : TEXTS.reason}
        value={order.destination_kind === KINDS.PROJECT ? order.project_label : internalLabel}
        valueSx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', fontSize: 14 }}
        sx={drawerFieldSpan(8)}
      />
    </DrawerFormSection>
  );
};

export default SupplyOrderDestinationSummary;
